// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__1Td7a","p":"style_p__3XQrI","cta":"style_cta__27T1i","icon":"style_icon__15Xlw"};